













import { Vue, Component } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { Dictionary } from '@/types/general'
import { Field, FieldSet, EditorEntry } from '@/store/editor/types'
import { RootState } from '@/store/types'
import EditorTagSelect from '@/components/app/main/editor/EditorTagSelect.vue'

@Component({ name: 'editor-fields', components: { EditorTagSelect } })
export default class EditorFields extends Vue {
    /**
     * Currently open entry
     */
    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    /**
     * The fields available in the entry
     */
    get fields(): FieldSet {
        return this.entry.fields
    }

    get displayedFields(): Dictionary<Field> {
        const { title, ...fields } = this.fields
        return fields
    }
}
